export const SEO_REDIRECT_URL = '/v1/seo-redirects';
export const REMOVE_SEO_REDIRECT_URL = `${SEO_REDIRECT_URL}/:id`;
